<script setup lang="ts">
import { computed } from 'vue'
import type { SelectOption, Tone } from '@/types/page'
import { statusTone } from '@/utils/format'

const props = defineProps<{
  value?: string | boolean | number | null
  label?: string
  options?: SelectOption[]
  tone?: string
}>()

const resolved = computed(() => {
  const key = String(props.value ?? '')
  const option = props.options?.find(item => String(item.value) === key)
  const text = props.label ?? option?.label ?? (typeof props.value === 'boolean' ? (props.value ? '是' : '否') : key)
  const rawTone = props.tone ?? option?.tone ?? statusTone(text)
  const tone: Tone | 'neutral' = ['success', 'info', 'warning', 'danger', 'purple', 'cyan', 'neutral'].includes(rawTone)
    ? (rawTone as Tone | 'neutral')
    : 'neutral'
  return { text: text || '—', tone }
})
</script>

<template>
  <span class="tag" :class="`tag--${resolved.tone}`">{{ resolved.text }}</span>
</template>
